import { createSelector } from 'reselect';
import { RootState } from '../../../types';
import { EntityTypes } from '../../../constants/entities';
import { IEntityReducer } from 'core/reducers/entities';
import { IOrganisationSystem, IOrganisationSystemDAO, ISystemAttribute } from 'types/domain/system';
import { getEntities } from '../utils/getEntities';
import { parseSystemDAO } from './system';

const entity = (state: RootState) => state.entity.present;
const id = (state: RootState, id) => id;

export const selectOrganisationSystems = createSelector([entity], (entity: IEntityReducer) => {
  return Object.values(entity[EntityTypes.ORG_SYSTEM])
    .filter(g => g.status > -1)
    .map((system: IOrganisationSystem) => parseOrganisationSystemDAO(entity, system.id));
});

export const selectOrganisationSystem = createSelector([entity, id], parseOrganisationSystemDAO);

export function parseOrganisationSystemDAO(entity, id) {
  const system: IOrganisationSystem = entity[EntityTypes.ORG_SYSTEM][id];

  if (!system) return null;

  return {
    ...system,
    system: parseSystemDAO(entity, system.systemId),
    service: system.systemServiceId ? entity[EntityTypes.SYSTEM_SERVICE][system.systemServiceId] : null,
    values: getEntities(entity, EntityTypes.ORG_SYSTEM_VALUE, 'organisationSystemId', system.id),
    text: system.textId ? entity[EntityTypes.TEXT][system.textId] : null,
    attributes: getEntities(entity, EntityTypes.SYSTEM_ATTRIBUTE, 'systemId', system.systemId)
    // .filter(
    //   (attribute: ISystemAttribute) =>
    //     attribute.systemServiceId ? attribute.systemServiceId === system.systemServiceId : true,
    // ),
  } as IOrganisationSystemDAO;
}
